// Error message HTML templates
let html_error_messages_prefix = '<div class="form-status__message form-status__message--error fs-body-75"><ul tabindex="0" data-form-status="">';
let html_error_messages_suffix = '</ul></div>';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  const element_register_form = document.querySelectorAll('#customer_login');

  element_register_form.forEach((form) => {
    const element_submit_button_2 = form.querySelector('#registerFormButton');

    if(form && element_submit_button_2) {
      element_submit_button_2.onclick = function(e) {
        e.preventDefault();

        // Clear existing error messages
        let error_messages_elements_1 = form.querySelector('.form-status');
        let error_messages_elements_2 = document.getElementsByClassName('form-status');
        let error_messages_elements_3 = document.getElementsByClassName('form-status__message');

        if(error_messages_elements_1) {
          let error_messages_children = Array.prototype.slice.call(error_messages_elements_1.childNodes);
          error_messages_children.forEach(function(child) {
            error_messages_elements_1.removeChild(child);
          });
        }

        if(error_messages_elements_2) {
          while(error_messages_elements_2.length > 0) {
            error_messages_elements_2[0].parentNode.removeChild(error_messages_elements_2[0]);
          }
        }

        if(error_messages_elements_3) {
          while(error_messages_elements_3.length > 0) {
            error_messages_elements_3[0].parentNode.removeChild(error_messages_elements_3[0]);
          }
        }

        custom_login(form);
      }
    }
  });
});

// Custom login function
function custom_login(form) {
  let data_email = form.getElementsByClassName('data_input_email')[0].value;
  let data_password = form.getElementsByClassName('data_input_password')[0].value;
  
  if(!data_email || !data_password) {
    form.insertAdjacentHTML('beforebegin', html_error_messages_prefix + '<li>Please fill out the email and password fields.</li>' + html_error_messages_suffix);
    return;
  }

  let account_login = fetch('/account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: serialize_form(form)
  }).then(function(response) {
    return response.text();
  }).then(function(html) {
    if(html.indexOf('form-status__message--error') !== -1) {
      let temp_element = document.createElement('body');
      temp_element.innerHTML = html;
      let html_element_1 = temp_element.querySelector('.form-status');
      form.insertBefore(html_element_1, form.firstChild);
    } else {
      form.submit();
    }
  });
  
  return account_login;
}

// Custom forgot password function
function custom_fp(form) {
  let data_email = form.getElementsByClassName('data_input_email')[0].value;
  
  if(!data_email) {
    form.insertAdjacentHTML('beforebegin', html_error_messages_prefix + '<li>Please fill out the email field.</li>' + html_error_messages_suffix);
    return;
  }

  let account_fp = fetch('/account/recover', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: serialize_form(form)
  }).then(function(response) {
    return response.text();
  }).then(function(html) {
    if(html.indexOf('form-status__message--error') !== -1) {
      let temp_element = document.createElement('body');
      temp_element.innerHTML = html;
      let html_element_1 = temp_element.querySelector('.form-status');
      form.insertBefore(html_element_1, form.firstChild);
    } else {
      form.submit();
    }
  });
  
  return account_fp;
}